import { translate } from "app/filters/i18nFilter";
import SavedSearchesEmptyCardActions from "app/pages/sales-intelligence/pages/home/components/SavedSearchesCard/SavedSearchesEmptyCardActions";
import { savedSearchesColumns } from "app/pages/sales-intelligence/pages/home/configuration/table-columns/saved-searches/columns";
import RedirectButtonTracked from "app/pages/sales-intelligence/pages/home/containers/RedirectButton/RedirectButtonTracked";
import type { ResultsViewModel } from "app/pages/sales-intelligence/pages/home/types/models";
import type { SavedSearchesRow } from "app/pages/sales-intelligence/pages/home/types/savedSearchesDto";
import {
    StyledContentFooter,
    StyledResultsContainer,
    StyledResultsTableWrapper,
    StyledSavedSearchResultsTable,
} from "../styles";
import EmptySavedSearchesView from "./EmptySavedSearchesView";

type Props = Pick<ResultsViewModel<SavedSearchesRow>, "results" | "areResultsOverLimit" | "metadata"> & {
    onRedirectToSearch(): void;
    onViewAll(): void;
};

const SavedSearchesResultsView = ({ results, areResultsOverLimit, metadata, onViewAll, onRedirectToSearch }: Props) => {
    const saveSearchResultTable = (
        <StyledSavedSearchResultsTable
            data={results as SavedSearchesRow[]}
            columns={savedSearchesColumns}
            metadata={metadata}
            noDataComponent={
                <EmptySavedSearchesView
                    actions={
                        <SavedSearchesEmptyCardActions
                            metadata={metadata}
                            onRedirectToSearch={onRedirectToSearch}
                        />
                    }
                />
            }
        />
    );
    return (
        <StyledResultsContainer>
            {areResultsOverLimit ? (
                <>
                    {saveSearchResultTable}
                    <StyledContentFooter>
                        <RedirectButtonTracked
                            metadata={metadata}
                            type="flat"
                            onClick={onViewAll}
                        >
                            {translate("si.pages.home.card.saved-searches.action.all-saved-searches")}
                        </RedirectButtonTracked>
                    </StyledContentFooter>
                </>
            ) : (
                <StyledResultsTableWrapper>{saveSearchResultTable}</StyledResultsTableWrapper>
            )}
        </StyledResultsContainer>
    );
};

export default SavedSearchesResultsView;
